import aboutUs1Xs from './about-us-1-xs.jpg';
import aboutUs1Lg from './about-us-1-lg.jpg';
import aboutUs2Xs from './about-us-2-xs.jpg';
import aboutUs2Lg from './about-us-2-lg.jpg';

export default {aboutUs1Xs, aboutUs1Lg, aboutUs2Xs, aboutUs2Lg}
